import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import "../assets/css/HomePage.css";
import { c1, c2, c3 } from "../assets/images";

function getLangPath(path, lang) {
  if (lang === "bn") {
    if (path.startsWith("/bn")) return path;
    return `/bn${path.startsWith("/") ? path : "/" + path}`;
  }
  return path.startsWith("/") ? path : "/" + path;
}

/* ---------- SEO helpers ---------- */
function setMetaName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
function setMetaProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
// порядок атрибутов: href → hreflang
function upsertLink(rel, href, extra = {}) {
  if (!href) return;
  let selector = `link[rel="${rel}"]`;
  if (extra.hreflang) selector += `[hreflang="${extra.hreflang}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
    document.head.appendChild(el);
  } else {
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
  }
}
function stripQueryHash(url) {
  try {
    const u = new URL(url);
    u.search = "";
    u.hash = "";
    return u.toString();
  } catch {
    return url;
  }
}
function toAbsoluteUrl(maybeRelative) {
  if (!maybeRelative) return "";
  if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
  return `${window.location.origin}${maybeRelative.startsWith("/") ? "" : "/"}${maybeRelative}`;
}

const Casino = () => {
  const { pathname } = useLocation();
  const lang = pathname.startsWith("/bn") ? "bn" : "en";

useEffect(() => {
  const origin = window.location.origin;
  const cleanPath = pathname || "/";
  const currentAbsUrl = stripQueryHash(`${origin}${cleanPath}`);

  // hreflang альтернативы
  const urlEn = `${origin}${cleanPath.replace(/^\/bn/, "") || "/"}`;
  const urlBn = `${origin}${getLangPath(cleanPath.replace(/^\/bn/, ""), "bn")}`;

  // ===== Тексты (EN → BN перевод) =====
  const pageTitleEN = " HHBD Casino — Play Live Dealers & Slots in Bangladesh";
  const pageDescEN =
    " Experience the thrill of HHBD Casino with live blackjack, roulette & high-RTP slots. Secure BDT deposits via bKash & Nagad, fair gameplay, and instant payouts make HHBD the ultimate casino for Bangladeshi players.";

  const pageTitleBN = "HHBD ক্যাসিনো — বাংলাদেশে লাইভ ডিলার এবং স্লট খেলুন";
  const pageDescBN =
    "লাইভ ব্ল্যাকজ্যাক, রুলেট এবং উচ্চ-আরটিপি স্লট সহ HHBD ক্যাসিনোর রোমাঞ্চ উপভোগ করুন। বিকাশ এবং নগদের মাধ্যমে নিরাপদ বাংলাদেশি টাকা জমা, ন্যায্য গেমপ্লে এবং তাৎক্ষণিক অর্থ প্রদান HHBD কে বাংলাদেশি খেলোয়াড়দের জন্য সেরা ক্যাসিনো করে তোলে।";

  const pageKeywordsEN =
    "HHBD Casino, live dealer Bangladesh, roulette BD, blackjack Bangladesh, baccarat BD, BDT casino games, trusted online casino";
  const pageKeywordsBN =
    "HHBD ক্যাসিনো, লাইভ ডিলার, রুলেট বাংলাদেশ, ব্ল্যাকজ্যাক বিডি, ব্যাকার্যাট গেম, অনলাইন ক্যাসিনো বাংলাদেশ";

  const isBN = lang === "bn";

  // ===== Требование: все ТАЙТЛЫ (обычные) — UPPERCASE; микроразметка — UPPERCASE =====
  const pageTitle = (isBN ? pageTitleBN : pageTitleEN).toUpperCase(); // тайтл сразу в верхнем регистре
  const pageDesc = isBN ? pageDescBN : pageDescEN;                    // description — обычный регистр
  const pageKeywords = isBN ? pageKeywordsBN : pageKeywordsEN;        // keywords — обычный регистр

  // <title> + базовые meta
  document.title = pageTitle;           // ✅ UPPERCASE
  setMetaName("description", pageDesc); // обычный регистр
  setMetaName("keywords", pageKeywords);// обычный регистр

  // Canonical + hreflang (+ x-default → en)
  upsertLink("canonical", currentAbsUrl);
  upsertLink("alternate", urlEn, { hreflang: "en" });
  upsertLink("alternate", urlBn, { hreflang: "bn" });
  upsertLink("alternate", urlEn, { hreflang: "x-default" });

  // -------- Open Graph --------
  const ogImage = toAbsoluteUrl(c1);
  setMetaProperty("og:type", "website");
  setMetaProperty("og:site_name", "HHBD");
  setMetaProperty("og:url", currentAbsUrl);
  setMetaProperty("og:title", pageTitle);      // ✅ UPPERCASE
  setMetaProperty("og:description", pageDesc); // обычный регистр
  setMetaProperty("og:image", ogImage);
  setMetaProperty("og:image:alt", isBN ? pageTitleBN : pageTitleEN); // alt — читаемый
  setMetaProperty("og:locale", isBN ? "bn_BD" : "en_US");
  setMetaProperty("og:locale:alternate", isBN ? "en_US" : "bn_BD");

  // -------- Twitter (тайтл в UPPERCASE + twitter:url) --------
  const twitterSite = "@HHBD_official";     // ← замени на реальный @ бренда
  const twitterCreator = "@HHBD_official";  // ← или автора/редактора
  const twitterImageAlt = isBN
    ? "HHBD-তে আসল ক্যাসিনো অ্যাকশন উপভোগ করুন - পেশাদার ডিলার এবং বাংলাদেশী টাকায় স্টেক সহ লাইভ রুলেট, ব্ল্যাকজ্যাক এবং ব্যাকার্যাট।"
    : "Enjoy real casino action at HHBD – live roulette, blackjack and baccarat with professional dealers and BDT stakes.";

  setMetaName("twitter:card", "summary_large_image");
  setMetaName("twitter:title", pageTitle);         // ✅ UPPERCASE
  setMetaName("twitter:description", pageDesc);    // обычный регистр
  setMetaName("twitter:image", ogImage);
  setMetaName("twitter:image:alt", twitterImageAlt);
  setMetaName("twitter:url", currentAbsUrl);       // ✅ добавлено
  if (twitterSite) setMetaName("twitter:site", twitterSite);
  if (twitterCreator) setMetaName("twitter:creator", twitterCreator);

  // label/data пары (до 2)
  setMetaName("twitter:label1", isBN ? "গেম টাইপ" : "Game Types");
  setMetaName("twitter:data1", isBN ? "রুলেট, ব্ল্যাকজ্যাক, ব্যাকার্যাট, স্লটস" : "Roulette, Blackjack, Baccarat, Slots");
  setMetaName("twitter:label2", isBN ? "প্ল্যাটফর্ম" : "Platform");
  setMetaName("twitter:data2", "Android");

  
}, [lang, pathname]);


  return (
    <>
      {/* --- ENGLISH VERSION --- */}
      <script
  type="application/ld+json"
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: (() => {
      const isBN = lang === "bn";
      const origin =
        typeof window !== "undefined" ? window.location.origin : "https://example.com";
      const currentAbsUrl =
        typeof window !== "undefined"
          ? stripQueryHash(`${origin}${pathname || "/"}`)
          : "https://example.com/casino";

      // Visible copy (JSON-LD NAME/DESCRIPTION uppercased to match your rule)
      const titleEN = " HHBD Casino — Play Live Dealers & Slots in Bangladesh";
      const descEN =
        " Experience the thrill of HHBD Casino with live blackjack, roulette & high-RTP slots. Secure BDT deposits via bKash & Nagad, fair gameplay, and instant payouts make HHBD the ultimate casino for Bangladeshi players.";

      const titleBN = "HHBD ক্যাসিনো — বাংলাদেশে লাইভ ডিলার এবং স্লট খেলুন";
      const descBN =
        "লাইভ ব্ল্যাকজ্যাক, রুলেট এবং উচ্চ-আরটিপি স্লট সহ HHBD ক্যাসিনোর রোমাঞ্চ উপভোগ করুন। বিকাশ এবং নগদের মাধ্যমে নিরাপদ বাংলাদেশি টাকা জমা, ন্যায্য গেমপ্লে এবং তাৎক্ষণিক অর্থ প্রদান HHBD কে বাংলাদেশি খেলোয়াড়দের জন্য সেরা ক্যাসিনো করে তোলে।";

      const pageTitleCaps = (isBN ? titleBN : titleEN).toUpperCase();
      const pageDescCaps  = (isBN ? descBN  : descEN );
      const inLang = isBN ? "bn" : "en";

      // Organization description (uppercased in microdata)

      // Primary image for this page (c1) → absolute
      const ogImage =
        typeof c1 === "string"
          ? (/^https?:\/\//i.test(c1) ? c1 : `${origin}${c1.startsWith("/") ? "" : "/"}${c1}`)
          : `${origin}/favicon-512x512.png`;

      const jsonLd = [
        // WebPage (Casino)
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "url": currentAbsUrl,
          "name": pageTitleCaps,
          "inLanguage": inLang,
          "description": pageDescCaps,
          "isPartOf": { "@type": "WebSite", "name": "HHBD", "url": origin },
          "primaryImageOfPage": ogImage
        },

        // Organization
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": pageTitleCaps,
  "url": origin,
  "description": pageDescCaps,
  "logo": {c1}, 
  "address": {
    "@type": "PostalAddress",
    "addressCountry": {
      "@type": "Country",
      "name": "BD"
    },
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "support@ze77-bd.com",
      "availableLanguage": ["English", "বাংলা"]
    }
  ],

},

        // MobileApplication (no downloadUrl as requested)
        {
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": "HHBD APP",
          "inLanguage": inLang,
          "operatingSystem": "Android",
          "applicationCategory": "GameApplication",
          "url": `${origin}/app`,
          "image": ogImage,
          "offers": {
            "@type": "Offer",
            "price": "0",
            
          },
          "publisher": {
            "@type": "Organization",
            "name": "HHBD",
            "url": origin
          }
        }
      ];

      return JSON.stringify(jsonLd);
    })()
  }}
/>

      {lang === "en" && (
<>
    <section className="zHHBD-casinohero">
      <div className="zHHBD-casinohero__bg">
        <div className="zHHBD-casinohero__overlay"></div>
        <div className="zHHBD-casinohero__glow zHHBD-casinohero__glow--1"></div>
        <div className="zHHBD-casinohero__glow zHHBD-casinohero__glow--2"></div>
      </div>

      <div className="zHHBD-casinohero__container">
        <div className="zHHBD-casinohero__content">
          <header className="zHHBD-casinohero__header">
            <h1 className="zHHBD-casinohero__title">
              HHBD Casino – Your Live Gaming Hub in Bangladesh
            </h1>
            <p className="zHHBD-casinohero__desc">
              Dive straight into HHBD Casino, where each spin, deal, and decision
              sparks a brand-new surge of excitement. Roam through blockbuster video{" "}
              <Link to="/slots" className="zHHBD-casinohero__link">slots</Link>, timeless table{" "}
              <Link to="/games" className="zHHBD-casinohero__link">games</Link>, and a cinematic{" "}
              <Link to="/casino" className="zHHBD-casinohero__link">live dealer</Link> arena that mirrors the energy of a real casino floor.
              With protected play, proven fairness, and high-octane action at every turn, your next breakout win is only a click away.
            </p>
          </header>
          <div className="zHHBD-casinohero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-casinohero__btn zHHBD-casinohero__btn--main"
              title="Join HHBD Now"
            >
              Join HHBD Now
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-casinohero__btn zHHBD-casinohero__btn--ghost"
              title="Download APK"
            >
              Download APK
            </a>
          </div>
        </div>
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Casino – Step into live tables, real thrills, and unforgettable moments"
        >
          <img
            src={c1}
            alt="Elegant player at a roulette table with chips in hand, reflecting the upscale HHBD Casino atmosphere."
            title="HHBD Casino – Step into live tables, real thrills, and unforgettable moments"
          />
        </a>
      </div>
    </section>

    {/* ACTION */}
    <section className="zHHBD-action">
      <div className="zHHBD-action__bg">
        <div className="zHHBD-action__chips">
          <span className="zHHBD-action__chip zHHBD-action__chip--1"></span>
          <span className="zHHBD-action__chip zHHBD-action__chip--2"></span>
          <span className="zHHBD-action__chip zHHBD-action__chip--3"></span>
        </div>
        <div className="zHHBD-action__spark zHHBD-action__spark--1"></div>
        <div className="zHHBD-action__spark zHHBD-action__spark--2"></div>
      </div>

      <div className="zHHBD-action__container">
        <div className="zHHBD-action__content">
          <header className="zHHBD-action__header">
            <h2 className="zHHBD-action__title">
              Welcome to HHBD: The Ultimate Online Casino Playground
            </h2>
            <p className="zHHBD-action__desc">
              Enter HHBD’s digital floor—endless entertainment with VIP-level care at every step.
              Tailored for Bangladesh, our premium destination blends a vast roster of top-tier{" "}
              <Link to="/games" className="zHHBD-action__link">games</Link> with a secure, intuitive interface.
              Expect a standout experience engineered to keep you coming back for one more spin, one more hand, and one more win.
            </p>
          </header>

          <div className="zHHBD-action__cards-body">
            <div className="zHHBD-action__cards">
              <div className="zHHBD-action__block">
                <div className="zHHBD-action__block-text">
                  Our catalogue is fueled by industry-leading studios, guaranteeing crisp graphics,
                  smooth performance, and verified fairness across the board. Fresh releases roll out constantly beside fan-favourite classics,
                  so there’s always something new to discover. Crave turbo-charged{" "}
                  <Link to="/slots" className="zHHBD-action__link">slots</Link> or skill-driven table{" "}
                  <Link to="/games" className="zHHBD-action__link">games</Link>? HHBD matches every mood.
                </div>
              </div>
              <div className="zHHBD-action__block">
                <div className="zHHBD-action__block-text">
                  Trust and transparency lead everything we do. Your data and payments are safeguarded with advanced security,
                  and each <Link to="/games" className="zHHBD-action__link">game</Link> runs on certified RNG for unbiased results.
                  Play with confidence—HHBD pairs thrilling entertainment with a rigorously protected, responsible environment.
                </div>
              </div>
            </div>

            <figure className="zHHBD-action__figure">
              <a
                href="https://haruvest.com/W7DZsfpK"
                title="HHBD Casino – A glossy gateway to high-end online play"
              >
                <img
                  src={c2}
                  alt="Glamorous woman in a red dress enjoying the lively, luxe mood of HHBD Casino."
                  className="zHHBD-action__img"
                  title="HHBD Casino – A glossy gateway to high-end online play"
                />
              </a>
            </figure>
          </div>

          <div className="zHHBD-action__cta">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-action__btn"
              title="Play HHBD Casino"
            >
              Play HHBD Casino
            </a>
          </div>
        </div>
      </div>
    </section>

    {/* CATEGORIES */}
    <section className="zHHBD-categories">
      <div className="zHHBD-categories__bg">
        <div className="zHHBD-categories__spark zHHBD-categories__spark--left"></div>
        <div className="zHHBD-categories__spark zHHBD-categories__spark--right"></div>
      </div>

      <div className="zHHBD-categories__container">
        <header className="zHHBD-categories__header">
          <h2 className="zHHBD-categories__title">
            HHBD Casino Highlights That Supercharge Every Session
          </h2>
        </header>

        <div className="zHHBD-categories__grid">
          {/* CARD 1 */}
          <div className="zHHBD-categories__card">
            <div className="zHHBD-categories__card-content">
              <div className="zHHBD-categories__card-tag">
                <i className="fa-solid fa-gamepad"></i>
                Seamless Mobile Gameplay
              </div>
              <div className="zHHBD-categories__card-text">
                Take your favourite <Link to="/games" className="zHHBD-categories__link">casino games</Link> everywhere with our mobile-first site.
                The layout adapts beautifully to phones and tablets—no extra app needed—for a fast, fully responsive on-the-go experience.
              </div>
            </div>
          </div>

          {/* CARD 2 */}
          <div className="zHHBD-categories__card">
            <div className="zHHBD-categories__card-content">
              <div className="zHHBD-categories__card-tag">
                <i className="fa-solid fa-gift"></i>
                Fast & Secure Payments
              </div>
              <div className="zHHBD-categories__card-text">
                Use trusted local rails like bKash and Nagad—plus other protected options.
                Deposit and withdraw quickly with bank-grade safeguards, keeping your focus on play and payouts every time.
              </div>
            </div>
          </div>

          {/* CARD 3 */}
          <div className="zHHBD-categories__card">
            <div className="zHHBD-categories__card-content">
              <div className="zHHBD-categories__card-tag">
                <i className="fa-solid fa-indian-rupee-sign"></i>
                Round-the-Clock Support
              </div>
              <div className="zHHBD-categories__card-text">
                Our expert team is ready 24/7 via chat, email, and phone—solving problems quickly
                and offering clear, professional guidance whenever you need assistance.
              </div>
            </div>
          </div>

          {/* CARD 4 */}
          <div className="zHHBD-categories__card">
            <div className="zHHBD-categories__card-content">
              <div className="zHHBD-categories__card-tag">
                <i className="fa-solid fa-mobile-screen"></i>
                Tailor Your Experience
              </div>
              <div className="zHHBD-categories__card-text">
                Shape your HHBD <Link to="/casino" className="zHHBD-categories__link">casino</Link> session exactly how you like it:
                save favourites, set deposit limits, and fine-tune notifications for a personalised{" "}
                <Link to="/games" className="zHHBD-categories__link">games</Link> journey—from first spin to final cashout.
              </div>
            </div>
          </div>

          {/* CARD 5 */}
          <div className="zHHBD-categories__card">
            <div className="zHHBD-categories__card-content">
              <div className="zHHBD-categories__card-tag">
                <i className="fa-solid fa-shield-check"></i>
                Daily Missions & Perks
              </div>
              <div className="zHHBD-categories__card-text">
                Keep the momentum rolling with bite-size challenges and bonus drops.
                Complete missions at the HHBD <Link to="/bonuses" className="zHHBD-categories__link">bonuses</Link> hub and the{" "}
                <Link to="/casino" className="zHHBD-categories__link">casino</Link> to claim perks, prizes, and extra value every single day.
              </div>
            </div>
          </div>

          {/* CARD 6 (from Live Casino section) */}
          <div className="zHHBD-categories__card">
            <div className="zHHBD-categories__card-content">
              <div className="zHHBD-categories__card-tag">
                <i className="fa-solid fa-cards-blank"></i>
                Immersive Live Table Moments
              </div>
              <div className="zHHBD-categories__card-text">
                Step into the HHBD <Link to="/casino" className="zHHBD-categories__link">casino</Link> studio for an authentic online experience.
                Streamed in HD from professional venues, our live dealer <Link to="/games" className="zHHBD-categories__link">games</Link> combine real croupiers with real-time interaction—
                the ideal bridge between home comfort and the buzz of a casino.
              </div>
            </div>
          </div>
        </div>

        <div className="zHHBD-categories__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-categories__btn"
            title="Play HHBD Casino"
          >
            Play HHBD Casino
          </a>
        </div>
      </div>
    </section>

    {/* WHY US / LIVE CASINO */}
    <section className="zHHBD-whyus">
      <div className="container hr-cont">
        <header className="zHHBD-whyus__header">
          <h2 className="zHHBD-whyus__title">
            Explore the HHBD Casino Collection
          </h2>
        </header>
        <p className="zHHBD-whyus__desc">
          The HHBD <Link to="/casino" className="zHHBD-whyus__link">casino</Link> library is a hand-picked realm of thrills,
          organised so you can instantly focus on the{" "}
          <Link to="/games" className="zHHBD-whyus__link">game</Link> that fits your mood.
          We collaborate with top creators to deliver depth, variety, and constant expansion—an evolving universe ready to explore.
        </p>
      </div>

      <div className="zHHBD-whyus__container">
        {/* Left: Animated Visual */}
        <div className="zHHBD-whyus__imgbox">
          <div className="zHHBD-whyus__img-bg"></div>
          <a
            href="https://haruvest.com/W7DZsfpK"
            title="HHBD Casino – Live roulette thrills in real time from home"
          >
            <img
              src={c3}
              alt="Laptop with a live roulette broadcast, chips, and neon accents — the unmistakable HHBD Casino vibe."
              className="zHHBD-whyus__img"
              title="HHBD Casino – Live roulette thrills in real time from home"
            />
          </a>
          <div className="zHHBD-whyus__pulse"></div>
          <div className="zHHBD-whyus__floatingicon">
            <i className="fa-solid fa-shield-halved"></i>
          </div>
        </div>

        {/* Right: Content */}
        <div className="zHHBD-whyus__content">
          <div className="zHHBD-whyus__descwrap">
            <p className="zHHBD-whyus__desc">
              Our online <Link to="/slots" className="zHHBD-whyus__link">slots</Link> collection is unrivalled—classic fruits, atmospheric adventures,
              and modern video <Link to="/slots" className="zHHBD-whyus__link">slots</Link> packed with features and story-driven flair.
              Chase massive progressive jackpots, try innovative mechanics, and find a new favourite in a huge, always-fresh lineup.
            </p>
            <p className="zHHBD-whyus__desc">
              Prefer the strategy route? Sink into our table{" "}
              <Link to="/games" className="zHHBD-whyus__link">games</Link> suite:
              multi-variant Blackjack, Roulette, Baccarat, and Poker headline a timeless roster.
              Hone your approach, test your nerve, and savour enduring <Link to="/casino" className="zHHBD-whyus__link">casino</Link> staples built to outlast trends.
            </p>
          </div>

          <div className="zHHBD-whyus__cta">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-whyus__btn"
              title="Play HHBD Casino"
            >
              Play HHBD Casino
            </a>
          </div>
        </div>
      </div>
    </section>
  </>



      )}

      {/* --- BENGALI VERSION --- */}
      {lang === "bn" && (
  <>
    <section className="zHHBD-casinohero">
      <div className="zHHBD-casinohero__bg">
        <div className="zHHBD-casinohero__overlay"></div>
        <div className="zHHBD-casinohero__glow zHHBD-casinohero__glow--1"></div>
        <div className="zHHBD-casinohero__glow zHHBD-casinohero__glow--2"></div>
      </div>

      <div className="zHHBD-casinohero__container">
        <div className="zHHBD-casinohero__content">
          <header className="zHHBD-casinohero__header">
            <h1 className="zHHBD-casinohero__title">
             HHBD ক্যাসিনো - বাংলাদেশে আপনার লাইভ গেমিং হাব
            </h1>
            <p className="zHHBD-casinohero__desc">
              সরাসরি ঢুকে পড়ুন HHBD ক্যাসিনো-তে—যেখানে প্রতিটি স্পিন, প্রতিটি ডিল ও প্রতিটি সিদ্ধান্তে জেগে ওঠে নতুন রোমাঞ্চ।
              ব্লকবাস্টার ভিডিও{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লটস</Link>, সময়হীন টেবিল{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> এবং সিনেম্যাটিক{" "}
              <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">লাইভ ডিলার</Link> অ্যারেনায় ঘুরে দেখুন—যার এনার্জি আসল ক্যাসিনো ফ্লোরের মতোই।
              সুরক্ষিত খেলা, প্রমাণিত ন্যায্যতা এবং প্রতিটি মুহূর্তে হাই-অকটেন অ্যাকশন—আপনার পরের বড় জয় হতে পারে মাত্র এক ক্লিক দূরে।
            </p>
          </header>
          <div className="zHHBD-casinohero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-casinohero__btn zHHBD-casinohero__btn--main"
              title="এখনই HHBD-এ যোগ দিন"
            >
              এখনই HHBD-এ যোগ দিন
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-casinohero__btn zHHBD-casinohero__btn--ghost"
              title="APK ডাউনলোড করুন"
            >
              APK ডাউনলোড করুন
            </a>
          </div>
        </div>
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Casino – লাইভ টেবিল, বাস্তব রোমাঞ্চ ও অবিস্মরণীয় মুহূর্তে যোগ দিন"
        >
          <img
            src={c1}
            alt="রুলেট টেবিলে চিপ হাতে আভিজাত্যপূর্ণ প্লেয়ার—HHBD Casino-র প্রিমিয়াম আবহ।"
            title="HHBD Casino – লাইভ টেবিল, বাস্তব রোমাঞ্চ ও অবিস্মরণীয় মুহূর্তে যোগ দিন"
          />
        </a>
      </div>
    </section>

    {/* ACTION */}
    <section className="zHHBD-action">
      <div className="zHHBD-action__bg">
        <div className="zHHBD-action__chips">
          <span className="zHHBD-action__chip zHHBD-action__chip--1"></span>
          <span className="zHHBD-action__chip zHHBD-action__chip--2"></span>
          <span className="zHHBD-action__chip zHHBD-action__chip--3"></span>
        </div>
        <div className="zHHBD-action__spark zHHBD-action__spark--1"></div>
        <div className="zHHBD-action__spark zHHBD-action__spark--2"></div>
      </div>

      <div className="zHHBD-action__container">
        <div className="zHHBD-action__content">
          <header className="zHHBD-action__header">
            <h2 className="zHHBD-action__title">
              HHBD-এ স্বাগতম: আলটিমেট অনলাইন ক্যাসিনো প্লেগ্রাউন্ড
            </h2>
            <p className="zHHBD-action__desc">
              প্রবেশ করুন HHBD-র ডিজিটাল ফ্লোরে—প্রতিটি ধাপে VIP মানের কেয়ার সহ অশেষ বিনোদন।
              বাংলাদেশের জন্য টেইলারড এই প্রিমিয়াম ডেস্টিনেশন—টপ-টিয়ার{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> লাইব্রেরি ও নিরাপদ, বোধগম্য ইন্টারফেসকে একত্রে মিশিয়েছে।
              এক্সপেরিয়েন্সটি এমনভাবে তৈরি—আরও একবার স্পিন, আরও একবার হ্যান্ড, আরও একবার জয়ের টানে আপনি বারবার ফিরে আসবেন।
            </p>
          </header>

          <div className="zHHBD-action__cards-body">
            <div className="zHHBD-action__cards">
              <div className="zHHBD-action__block">
                <div className="zHHBD-action__block-text">
                  আমাদের ক্যাটালগ চালিত হয় ইন্ডাস্ট্রি-লিডিং স্টুডিও দিয়ে—যা নিশ্চিত করে ক্রিস্প গ্রাফিক্স,
                  স্মুথ পারফরম্যান্স ও যাচাইকৃত ফেয়ারনেস। ফ্যান-ফেভারিট ক্লাসিকের পাশাপাশি আসে নিয়ত নতুন রিলিজ—
                  তাই আবিষ্কারের সুযোগ ফুরোয় না। টার্বো-চার্জড{" "}
                  <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লটস</Link> চান, নাকি স্কিল-ড্রিভেন টেবিল{" "}
                  <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link>? HHBD প্রতিটি মুডেই মানানসই।
                </div>
              </div>
              <div className="zHHBD-action__block">
                <div className="zHHBD-action__block-text">
                  ট্রাস্ট ও ট্রান্সপারেন্সি—আমাদের প্রতিটি কাজের প্রথম শর্ত। আপনার ডেটা ও পেমেন্ট সুরক্ষিত থাকে অ্যাডভান্সড সিকিউরিটিতে,
                  এবং প্রতিটি <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেম</Link> চলে সার্টিফায়েড RNG-এ—যাতে ফলাফল থাকে নিরপেক্ষ।
                  আত্মবিশ্বাস নিয়ে খেলুন—HHBD মিলে দেয় উত্তেজনাপূর্ণ বিনোদন ও কঠোরভাবে সুরক্ষিত, দায়িত্বশীল পরিবেশ।
                </div>
              </div>
            </div>

            <figure className="zHHBD-action__figure">
              <a
                href="https://haruvest.com/W7DZsfpK"
                title="HHBD Casino – হাই-এন্ড অনলাইন প্লের চকচকে গেটওয়ে"
              >
                <img
                  src={c2}
                  alt="লাল পোশাকে গ্ল্যামারাস নারী—HHBD Casino-র প্রাণবন্ত, লাক্স মুড উপভোগ করছেন।"
                  className="zHHBD-action__img"
                  title="HHBD Casino – হাই-এন্ড অনলাইন প্লের চকচকে গেটওয়ে"
                />
              </a>
            </figure>
          </div>

          <div className="zHHBD-action__cta">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-action__btn"
              title="HHBD Casino খেলুন"
            >
              HHBD Casino খেলুন
            </a>
          </div>
        </div>
      </div>
    </section>

    {/* CATEGORIES */}
    <section className="zHHBD-categories">
      <div className="zHHBD-categories__bg">
        <div className="zHHBD-categories__spark zHHBD-categories__spark--left"></div>
        <div className="zHHBD-categories__spark zHHBD-categories__spark--right"></div>
      </div>

      <div className="zHHBD-categories__container">
        <header className="zHHBD-categories__header">
          <h2 className="zHHBD-categories__title">
            প্রতিটি সেশনকে সুপারচার্জ করে এমন HHBD Casino হাইলাইটস
          </h2>
        </header>

        <div className="zHHBD-categories__grid">
          {/* CARD 1 */}
          <div className="zHHBD-categories__card">
            <div className="zHHBD-categories__card-content">
              <div className="zHHBD-categories__card-tag">
                <i className="fa-solid fa-gamepad"></i>
                সিমলেস মোবাইল গেমপ্লে
              </div>
              <div className="zHHBD-categories__card-text">
                আমাদের মোবাইল-ফার্স্ট সাইটে যেকোনো জায়গায় নিয়ে চলুন আপনার প্রিয়{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">ক্যাসিনো গেমস</Link>।
                অতিরিক্ত অ্যাপ ছাড়াই লেআউট সুন্দরভাবে খাপ খায় ফোন ও ট্যাবলেটে—সুপার ফাস্ট, পুরোপুরি রেসপনসিভ অন-দ্য-গো অভিজ্ঞতা।
              </div>
            </div>
          </div>

          {/* CARD 2 */}
          <div className="zHHBD-categories__card">
            <div className="zHHBD-categories__card-content">
              <div className="zHHBD-categories__card-tag">
                <i className="fa-solid fa-gift"></i>
                দ্রুত ও নিরাপদ পেমেন্ট
              </div>
              <div className="zHHBD-categories__card-text">
                bKash ও Nagad-এর মতো বিশ্বস্ত লোকাল রেইল—সাথে অন্যান্য সুরক্ষিত অপশন।
                ব্যাংক-গ্রেড সিকিউরিটিতে দ্রুত ডিপোজিট ও উইথড্র—ফোকাস থাকুক খেলা ও পেআউটে।
              </div>
            </div>
          </div>

          {/* CARD 3 */}
          <div className="zHHBD-categories__card">
            <div className="zHHBD-categories__card-content">
              <div className="zHHBD-categories__card-tag">
                <i className="fa-solid fa-indian-rupee-sign"></i>
                ২৪/৭ সাপোর্ট
              </div>
              <div className="zHHBD-categories__card-text">
                আমাদের এক্সপার্ট টিম ২৪/৭—চ্যাট, ইমেইল ও ফোনে—দ্রুত সমস্যার সমাধান ও
                পরিষ্কার, প্রফেশনাল গাইডেন্স দিতে সদা প্রস্তুত।
              </div>
            </div>
          </div>

          {/* CARD 4 */}
          <div className="zHHBD-categories__card">
            <div className="zHHBD-categories__card-content">
              <div className="zHHBD-categories__card-tag">
                <i className="fa-solid fa-mobile-screen"></i>
                নিজের মতো করে খেলুন
              </div>
              <div className="zHHBD-categories__card-text">
                আপনার HHBD <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link> সেশনটি টিউন করুন—
                ফেভারিট সংরক্ষণ, ডিপোজিট লিমিট সেট ও নোটিফিকেশন কাস্টমাইজ করুন; প্রথম স্পিন থেকে শেষ ক্যাশআউট পর্যন্ত{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> যাত্রা থাকুক একদম আপন-মনমতো।
              </div>
            </div>
          </div>

          {/* CARD 5 */}
          <div className="zHHBD-categories__card">
            <div className="zHHBD-categories__card-content">
              <div className="zHHBD-categories__card-tag">
                <i className="fa-solid fa-shield-check"></i>
                ডেইলি মিশনস ও পার্কস
              </div>
              <div className="zHHBD-categories__card-text">
                ক্ষুদে চ্যালেঞ্জ ও বোনাস ড্রপে বজায় থাকুক গতি।
                HHBD <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> হাব এবং{" "}
                <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link> অংশে মিশন সম্পূর্ণ করে প্রতিদিনই পান পার্কস, প্রাইজ ও বাড়তি ভ্যালু।
              </div>
            </div>
          </div>

          {/* CARD 6 (from Live Casino section) */}
          <div className="zHHBD-categories__card">
            <div className="zHHBD-categories__card-content">
              <div className="zHHBD-categories__card-tag">
                <i className="fa-solid fa-cards-blank"></i>
                ইমার্সিভ লাইভ টেবিল মোমেন্টস
              </div>
              <div className="zHHBD-categories__card-text">
                সত্যিকারের অনলাইন ফিল পেতে ঢুকে পড়ুন HHBD <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link> স্টুডিওতে।
                প্রফেশনাল ভেন্যু থেকে HD স্ট্রিম—আমাদের লাইভ ডিলার{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> জুড়ে দেয় রিয়েল ক্রুপিয়ার ও রিয়েল-টাইম ইন্টারঅ্যাকশন—
                ঘরের আরাম ও ক্যাসিনোর বাজের নিখুঁত সেতু।
              </div>
            </div>
          </div>
        </div>

        <div className="zHHBD-categories__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-categories__btn"
            title="HHBD Casino খেলুন"
          >
            HHBD Casino খেলুন
          </a>
        </div>
      </div>
    </section>

    {/* WHY US / LIVE CASINO */}
    <section className="zHHBD-whyus">
      <div className="container hr-cont">
        <header className="zHHBD-whyus__header">
          <h2 className="zHHBD-whyus__title">
            HHBD Casino কালেকশন ঘুরে দেখুন
          </h2>
        </header>
        <p className="zHHBD-whyus__desc">
          HHBD <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link> লাইব্রেরি—হ্যান্ড-পিকড থ্রিলের ভাণ্ডার,
          যাতে মুডের সাথে মানানসই{" "}
          <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেম</Link> আপনি মুহূর্তেই খুঁজে পান।
          লিডিং ক্রিয়েটরদের সাথে কাজ করে আমরা দিই ভ্যারাইটি, ডেপথ ও নিত্য-নতুন সংযোজন—একটি ক্রমবর্ধমান ইউনিভার্স, এক্সপ্লোরের অপেক্ষায়।
        </p>
      </div>

      <div className="zHHBD-whyus__container">
        {/* Left: Animated Visual */}
        <div className="zHHBD-whyus__imgbox">
          <div className="zHHBD-whyus__img-bg"></div>
          <a
            href="https://haruvest.com/W7DZsfpK"
            title="HHBD Casino – ঘরে বসে রিয়েল-টাইম লাইভ রুলেট থ্রিল"
          >
            <img
              src={c3}
              alt="ল্যাপটপ স্ক্রিনে লাইভ রুলেট, পাশে চিপস ও নীয়ন অ্যাকসেন্ট—অপরিবর্তনীয় HHBD Casino ভাইব।"
              className="zHHBD-whyus__img"
              title="HHBD Casino – ঘরে বসে রিয়েল-টাইম লাইভ রুলেট থ্রিল"
            />
          </a>
            <div className="zHHBD-whyus__pulse"></div>
            <div className="zHHBD-whyus__floatingicon">
              <i className="fa-solid fa-shield-halved"></i>
            </div>
        </div>

        {/* Right: Content */}
        <div className="zHHBD-whyus__content">
          <div className="zHHBD-whyus__descwrap">
            <p className="zHHBD-whyus__desc">
              আমাদের অনলাইন <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লটস</Link> সংগ্রহ অতুলনীয়—ক্লাসিক ফ্রুট, অ্যাটমসফেরিক অ্যাডভেঞ্চার,
              আর আধুনিক ভিডিও <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লটস</Link>—ফিচার ও স্টোরি-ড্রিভেন ফ্লেয়ার সমৃদ্ধ।
              প্রগ্রেসিভ জ্যাকপটের পিছু নিন, ইনোভেটিভ মেকানিকস ট্রাই করুন, আর বিশাল—সবসময় টাটকা—লাইনআপে খুঁজে নিন নতুন ফেভারিট।
            </p>
            <p className="zHHBD-whyus__desc">
              কৌশলপন্থী? তবে ঢুকে পড়ুন আমাদের টেবিল{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> স্যুটে—
              বহু ভ্যারিয়েন্টের Blackjack, Roulette, Baccarat ও Poker শিরোনামে।
              পন্থা শান দিন, নার্ভ পরীক্ষা করুন, আর উপভোগ করুন চিরকালীন <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link> ক্লাসিক—ট্রেন্ড ছাড়িয়ে স্থায়ী।
            </p>
          </div>

          <div className="zHHBD-whyus__cta">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-whyus__btn"
              title="HHBD Casino খেলুন"
            >
              HHBD Casino খেলুন
            </a>
          </div>
        </div>
      </div>
    </section>
  </>



      )}
    </>
  );
};

export default Casino;
